export const DARK_MODE = `
@media (prefers-color-scheme: dark) {
  .sid-theme-root__auto path { fill: white; }
}

.sid-theme-root__dark path { fill: white; }
`;
